var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-layout"},[(_vm.$GLOBAL_CONFIG.imageDirName === 'zhengzhou')?_c('zhengzhou'):(_vm.$GLOBAL_CONFIG.imageDirName === 'guangdong')?_c('guangdong'):_c('zhengzhou')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }